import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import { invitationsApi } from '../api/invitationsApi';
import type { SPClientInvitation } from '../types/sp-client-management.types';

export type InviteClientRequest = {
  clientFirstName: string;
  clientLastName: string;
  clientEmail: string;
  personalMessage?: string;
  referredProviderId?: string;
  referredResourceId?: string;
};

type UseInviteClientOptions = {
  onSuccess?: (data: SPClientInvitation) => void;
  onError?: (error: Error) => void;
};

export function useInviteClient(
  providerId: string,
  options?: UseInviteClientOptions
): UseMutationResult<SPClientInvitation, Error, InviteClientRequest> {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: InviteClientRequest) =>
      invitationsApi.create(providerId, data),

    onSuccess: (data) => {
      // Invalidate client list to refetch
      queryClient.invalidateQueries({
        queryKey: ['sp-clients', providerId],
      });

      // Call custom onSuccess callback if provided
      options?.onSuccess?.(data);
    },

    onError: (error) => {
      // Call custom onError callback if provided
      options?.onError?.(error);
    },
  });
}
